var map = {
	"./GBGK-Logo.jpg": 4149,
	"./Logo_VVC.jpg": 2800,
	"./coach-higareda.jpg": 3143,
	"./coach-placeholder.jpg": 4285,
	"./coach-santiago.jpg": 5348,
	"./coach-uphaus.jpg": 5861,
	"./coach-vander-veen.jpg": 8882,
	"./coach-wang.jpg": 4336,
	"./pellegriniortho_weblogo.jpg": 4780
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4319;